var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorcerer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sorcerer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Class_Icons",
    "data-name": "Class Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sorcerer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.71,0c.24,0,2.87,17.45,4.54,22.77,1.3,4.13,2.57,8.28,3.92,12.41a120.48,120.48,0,0,0,5.39,13A91.85,91.85,0,0,1,70.65,73.6c1,7-2.54,15.84-7.36,20.79A19,19,0,0,1,43,98.73c-6.79-2.66-11-9.55-12.76-16.37a26.94,26.94,0,0,1-.84-10.29,79.24,79.24,0,0,1,2.53-12.34A82.18,82.18,0,0,1,36.25,48.4a117.08,117.08,0,0,0,5.39-12.46A129.86,129.86,0,0,0,46.47,18.1C47,15,49.84,2.86,49.71,0c.27,0,.12,2.59,0,0M48.5,66.28c-.14,2.34-1.71,1.86-2.91,4.9-.44-1.56.88-4.83-.17-6.69A8.53,8.53,0,0,1,43.49,68a9.75,9.75,0,0,0-1.83,5.61,8.38,8.38,0,0,0,1,3.38,8.65,8.65,0,0,1,.51,3.4c-.38-1-.94-1.45-2.35-1.48-.82-.16-.85-1.59-.47-2.4-1.16.24-1.23,3-1.14,3.61.28,1.91,1.4,3,2.53,4.52,1,1.28,1.51,2.76,3,3.57,1.74,1,3.4,1.55,5.21,1.08.42-.11.48.42,2.1.48.92,0,1.39-.76,1.56-1.77a13.51,13.51,0,0,0,4.62-2.12c2.11-1.89,1.54-7.42.19-9,.44,2.06-1.15,1.94-.53,3.32.19,1.25-1.9.61-2.73,1.12-.78.84-.57,1.39-1.11,2.34-.64-1.4.4-2.68.94-3.91A9,9,0,0,0,56.12,75a7.14,7.14,0,0,0-1.42-4.19,6.07,6.07,0,0,1-1.23-4.08c-1.6.44.44,7-1.35,8.87-1.63-1.72-.26-6.78-.35-8.36a16.07,16.07,0,0,0-1.63-6.89A17.19,17.19,0,0,1,48.7,57c-.31-1.23-.59-3.47-.21-4-1.43,2.07-.84,5.77-.4,7a22,22,0,0,1,.41,6.35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorcerer);
export default __webpack_public_path__ + "static/media/sorcerer.04974739f4d29db7247d63feb8c49f43.svg";
export { ForwardRef as ReactComponent };